export const COMMON_SAVE = 'COMMON_SAVE';

export const commonAddData = ({ key, data, meta }) => ({
  type: COMMON_SAVE,
  key,
  payload: data,
  meta,
});
